// Eavenest custom product gallery.
// Cross-fades the fixed hero on thumbnail click. No layout movement, no native deps.
class EvGallery extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-ev-slide]'));
    this.thumbs = Array.from(this.querySelectorAll('[data-ev-thumb]'));
    this.rail = this.querySelector('[data-ev-rail]');
    this.index = 0;

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        this.select(Number(thumb.dataset.evThumb));
      });
    });

    const prev = this.querySelector('[data-ev-prev]');
    const next = this.querySelector('[data-ev-next]');
    if (prev) prev.addEventListener('click', () => this.select(this.index - 1));
    if (next) next.addEventListener('click', () => this.select(this.index + 1));
  }

  select(i) {
    const count = this.slides.length;
    if (!count) return;
    const idx = (i + count) % count; // wrap for chevrons
    if (idx === this.index) return;
    this.index = idx;

    this.slides.forEach((slide, s) => {
      const active = s === idx;
      slide.classList.toggle('is-active', active);
      if (active) slide.removeAttribute('aria-hidden');
      else slide.setAttribute('aria-hidden', 'true');
    });

    this.thumbs.forEach((thumb, t) => {
      const active = t === idx;
      thumb.classList.toggle('is-active', active);
      if (active) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });

    const activeThumb = this.thumbs[idx];
    if (activeThumb) {
      activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
  }
}

if (!customElements.get('ev-gallery')) {
  customElements.define('ev-gallery', EvGallery);
}
